import {Component, Input} from '@angular/core';
import {NavController, Tabs} from 'ionic-angular';

/**
 * Generated class for the LoginRequiredComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'login-required',
    templateUrl: 'login-required.html'
})
export class LoginRequiredComponent {

    @Input() referralTabIndex: string;

    constructor(private nav: NavController) {

    }

    goToProfile() {
        if (this.referralTabIndex){
          localStorage.setItem('refer', String(this.referralTabIndex));
        }
        let t: Tabs = this.nav.parent;
        t.select(5);
    }

}



// WEBPACK FOOTER //
// ./src/components/login-required/login-required.ts